// extracted by mini-css-extract-plugin
export default {"projects_block":"ResumeProjects_projects_block__sh0ND","project_item":"ResumeProjects_project_item__EXO-G"};